<template>
    <div id="question">
        <mt-loadmore :bottom-method="getFeedbackListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <ul>
                <li v-for="item in questions" :key="item.id">
                    <div class="liHeader">
                        <div>工单号：{{ item.id }}</div>
                        <div>状态： {{showTxtByState(item.disposeState)}}</div>
                    </div>
                    <div class="liMain">
                        <div>{{ item.problemContent }}</div>
                    </div>
                    <div class="liFooter">
                        <div>{{ item.currentTime }}</div>
                        <div>
                            <mt-button type="primary" size="small" class="line-button line-button--mini" @click="goToDetail(item.id)">查看工单</mt-button>
                            <mt-button type="primary" size="small" class="line-button line-button--mini" @click="deleteFeedbackHandler(item.id)">删除工单</mt-button>
                        </div>
                    </div>
                </li>
            </ul>
        </mt-loadmore>
    </div>
</template>
<script>
import {getFeedbackList, deleteFeedback, wxRequest} from '@/api/user'
export default {
    data(){
        return{
            questions: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            allLoaded: false
        }
    },
    methods: {
        showTxtByState(state){
            if(state == 1){
                return '未处理'
            }else if(state == 2){
                return '已处理'
            }
        },
        deleteFeedbackHandler(id){            
            this.$messagebox.confirm('您确定删除吗？').then(action => {
                if(action == 'confirm'){
                    wxRequest("userProblem/delete", {id}, "post").then(res => {
                        if(res.data.code == 200){
                            this.$toast({
                                message: '删除成功',
                                position: 'middle',
                                duration: 1500
                            })
                            var disposeState = this.$route.query.disposeState;
                            this.getFeedbackListHandler(disposeState);
                        }
                    })
                }
            })
        },
        getFeedbackListHandler(disposeState){
            if(!this.isLine){
                var iccid = sessionStorage.getItem('lineComplaintText');
                if(!sessionStorage.getItem('lineComplaintText')){
                    return;//链接进来没输入不显示
                }
            }else {
                var iccid = this.$store.state.iccid;
            }
            this.pageNo += 1;
            console.log('y:' + this.pageNo)
            
            let data = {
                // iccid: localStorage.getItem('iccid'),
                pageNo: this.pageNo,
                perPageNum: this.perPageNum,
                iccid,
                disposeState
            }
            wxRequest("userProblem/userInfo", data, "post").then(res => {
                if(res.data.code == 200){
                    // this.questions = res.data.data.resultList;
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }

                    this.questions = this.questions.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                    
                }
            })
        },
        goToDetail(id){
            this.$router.push('/user/questionDetail?id=' + id)
        }
    },
    watch:{
        '$route': function(to, from){
            var disposeState = to.query.disposeState;
            this.pageNo = 0;
            this.questions = [];
            this.allLoaded = false;
            this.getFeedbackListHandler(disposeState);            
            console.log('t:' + this.pageNo)
        }
    },
    created(){
        var disposeState = this.$route.query.disposeState;
        this.getFeedbackListHandler(disposeState);
    }    
}
</script>
<style lang="less">
#question {
    ul {        
        li {
            margin-top: 10px;
            background: #fff;
        }
        .liHeader, .liFooter {
            display: flex;
            justify-content: space-between;
            padding: 0 3%;
            line-height: 36px;
        }
        .liMain {
            min-height:60px;
            padding: 6px 3%;
            line-height: 1.5em;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            div {
                word-break: break-all;
            }
        }
        .liFooter button {
            margin-left: 10px;
        }
    }
}
</style>
